export default "__VITE_ASSET__CHTWtBwx__"